module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secondary-certification-body"
  }, [(_vm.infoSuc === 'success') ? _c('div', {
    staticClass: "info-suc"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('span', [_vm._v("验证码消息已发送至："), _c('span', {
    staticClass: "information-tools"
  }, [_vm._v(_vm._s(_vm.appName))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    class: {
      err: _vm.errInfo
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, function($event) {
        _vm.getInput()
      }]
    }
  }), _vm._v(" "), (_vm.isGetCode) ? _c('div', {
    staticClass: "getCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "again"
  }, [_vm._v(_vm._s(_vm.time) + "s后重发")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errInfo),
      expression: "errInfo"
    }],
    staticClass: "err-info"
  }, [_vm._v(_vm._s(_vm.errInfo))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    class: {
      active: _vm.allowLogin
    },
    on: {
      "click": _vm.loginHandler
    }
  }, [_vm._v("\n      登录\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.infoSuc === 'error') ? _c('div', {
    staticClass: "info-err"
  }, [_c('img', {
    attrs: {
      "src": _vm.errIcon,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("验证码发送失败")]), _vm._v(" "), _c('div', {
    staticClass: "err-details"
  }, [_vm._v("未找到对应的企业微信用户，请联系管理员处理")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoSuc !== 'init'),
      expression: "infoSuc !== 'init'"
    }],
    staticClass: "switch-account"
  }, [_c('span', {
    on: {
      "click": _vm.switchAccount
    }
  }, [_vm._v("切换账号")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518256c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/secondary-certification/secondary-certification.vue
// module id = 219
// module chunks = 3